import { styled } from '@stitches/react';

export const SongInfoWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  overflow: 'hidden',

  'h3, p': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const FlexBetweenWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'center',
});
